import { Video, Clock, Users, MessageSquare, HelpCircle } from "lucide-react";
import ZoomJoinCard from "@/components/ZoomJoinCard";

const MeetingFlow = () => {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-[#003056]/10 text-[#003056] px-4 py-2 rounded-full mb-4 text-sm font-medium">
            <Video className="h-4 w-4" />
            Delta via Zoom
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#003056] mb-4">
            Så går mötet till
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
          <ZoomJoinCard />

          <div className="space-y-4">
            <div className="flex gap-3">
              <Clock className="h-5 w-5 text-[#FF6D29] flex-shrink-0 mt-0.5" />
              <p className="text-slate-600 leading-relaxed">
                Zoom öppnar cirka 10 till 15 minuter före start.
              </p>
            </div>
            <div className="flex gap-3">
              <Users className="h-5 w-5 text-[#FF6D29] flex-shrink-0 mt-0.5" />
              <p className="text-slate-600 leading-relaxed">
                Vi börjar med en kort välkomst och delar sedan normalt upp oss i smågrupper
                med 3 till 5 personer.
              </p>
            </div>
            <div className="flex gap-3">
              <MessageSquare className="h-5 w-5 text-[#FF6D29] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold text-[#003056]">
                  1. Vem är du och vad arbetar du med?
                </p>
                <p className="text-slate-600 leading-relaxed">
                  En kort presentation, max cirka 3 minuter per person.
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <HelpCircle className="h-5 w-5 text-[#FF6D29] flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold text-[#003056]">
                  2. Vad skulle du vilja ha hjälp med?
                </p>
                <p className="text-slate-600 leading-relaxed">
                  Öppen dialog, erfarenhetsutbyte, idéer och kontakter.
                </p>
              </div>
            </div>
            <p className="text-slate-600 leading-relaxed">
              Efter den strukturerade delen fortsätter samtalen för den som vill stanna kvar.
            </p>
            <p className="text-[#003056] font-medium">
              Enkelt, avslappnat och med fokus på att lära känna varandra på riktigt.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetingFlow;
